module.exports = __webpack_public_path__ + "static/media/p3_2.c3f49e3b.png";